import { SearchPalette, SearchTrigger, useSearchShortcut } from "@majitap/ui";
import { useNavigate } from "@tanstack/react-router";
import { useCallback, useState } from "react";
import type { ConsoleSection } from "../nav";
import { actionGroup, pageGroup, SOURCES, useRecordSearch } from "../search";

const PLACEHOLDER = "Search orders, deliveries, customers, trucks…";

/**
 * ⌘K search (P8-06, Arc's command palette since P8-58): actions and pages the role may open,
 * filtered as you type, then the records it may see, searched on the API.
 */
export function ConsoleSearch({ menu, permissions }: { menu: ConsoleSection[]; permissions: readonly string[] }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const show = useCallback(() => setOpen(true), []);
  useSearchShortcut(show);
  const records = useRecordSearch(query, permissions);

  return (
    <>
      <SearchTrigger onOpen={show} placeholder={PLACEHOLDER} />
      <SearchPalette
        open={open}
        onOpenChange={setOpen}
        query={query}
        onQueryChange={setQuery}
        placeholder={PLACEHOLDER}
        hint="An order or delivery number, a name, a phone number, a plate, or a page. ↑↓ to move, Enter to open."
        groups={[actionGroup(permissions), pageGroup(menu), ...records.groups]}
        noResults={{
          label: (q) => `Nothing found for “${q}”`,
          description: "Try part of a name, a phone number, a plate, or an order or delivery number.",
        }}
        onSelect={(groupId, result) => {
          const source = SOURCES.find((s) => s.id === groupId);
          const href = source ? source.href(result.id) : result.id;
          setOpen(false);
          setQuery("");
          void navigate({ href });
        }}
      />
    </>
  );
}
